import FormFieldset, {
  FormFieldsetProps,
} from '../../../loan_application/components/FormFieldset';
import { FC } from 'react';

export const NewBorrowerFormFieldset: FC<FormFieldsetProps> = ({
  children,
  ...rest
}) => {
  return (
    <FormFieldset
      sx={{
        px: 3,
        pt: 2,
        pb: 2,
      }}
      titleProps={{
        variant: 'h6',
      }}
      {...rest}
    >
      {children}
    </FormFieldset>
  );
};

export default NewBorrowerFormFieldset;
